import { connect } from "react-redux";
import moment from "moment";
// Component
import BaseInfo from "components/CreateSurvey/BaseInfo";
// Action
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { openMessageDialog } from "redux/modules/messageDialog";
import { showSnackbar } from "redux/modules/snackbar";
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  setErrors,
  updateBaseInfo,
  setSurveyDetail,
  setBaseInfoLocale,
  changeBaseInfoUseLocales,
  changeBaseInfoItem,
  changeBaseInfoTerm,
  changeFreeCommentCheckbox1,
  changeFreeCommentCheckbox2,
  openSelectSurveyModal,
  setAlertConfig, setMailSendToIndividual
} from "redux/modules/createSurvey";
// Utils
import history from "utils/history";
import { convertLocaleKeyToName } from "utils/formatter";
import api from "api";
import { STATUS as SURVEY_STATUS } from "models/Survey";
import { validate as selectAttrValidate } from "../SelectAttr";
import { validate as baseWordValidate } from "../BaseWord";
import { validate as additionsValidate } from "../Additions";

const mapStateToProps = state => ({
  baseInfo: state.createSurvey.baseInfo,
  selectAttr: state.createSurvey.selectAttr,
  baseWord: state.createSurvey.baseWord,
  additions: state.createSurvey.additions,
  customer: state.createSurvey.customer,
  survey: state.createSurvey.survey,
  locales: state.createSurvey.locales,
  customerId: state.createSurvey.customerId,
  attrUpdatedAt: state.createSurvey.attrUpdatedAt,
  errors: state.createSurvey.errors,
  alertDays: state.createSurvey.alertDays,
  isChecked: state.createSurvey.isChecked,
  isMailSendToEmployee: state.createSurvey.isMailSendToEmployee,
});

const isInteger = numVal => {
  // チェック条件パターン
  const pattern = /^([1-9]\d*|0)$/;
  // 数値チェック
  return pattern.test(numVal);
};
export const validate = params => {
  const { baseInfo, survey, isChecked, alertDays } = params;

  const errors = [];
  if (baseInfo.useLocales.length === 0) {
    errors.push("アンケートで使用する言語を選択してください。");
  }

  if (isChecked) {
    if (alertDays === '' || alertDays === null || alertDays === undefined) {
      errors.push("アラートの日数を入力して下さい。");
    } else if (Number(alertDays) === 0) {
      errors.push("日数は0より大きい数値を設定してください。");
    }
  }

  baseInfo.useLocales.forEach(locale => {
    const item = baseInfo.items[locale];
    if (item.surveyName === "") {
      errors.push(
        `${convertLocaleKeyToName(locale)}のアンケート名を入力してください。`
      );
    }
    if (item.surveyExplain === "") {
      errors.push(
        `${convertLocaleKeyToName(
          locale
        )}のアンケートの説明を入力してください。`
      );
    }

    // 自由記入１の説明 の空欄チェック
    if (item.freeCommentDescription1 === "") {
      errors.push(
        `${convertLocaleKeyToName(
          locale
        )}の自由記入１の説明を入力してください。`
      );
    }

    // 自由記入２の説明 の空欄チェック
    const isFreeComment2Empty = item.freeCommentDescription2 === "";
    const isChecked2 = baseInfo.freeCommentCheck2;
    // チェックありで空欄か？
    if (isFreeComment2Empty && isChecked2) {
      errors.push(
        `${convertLocaleKeyToName(
          locale
        )}の自由記入２の説明を入力してください。`
      );
    }
  });
  if (!baseInfo.employees === "") {
    errors.push("対象者数を設定してください。");
  } else if (!isInteger(baseInfo.employees)) {
    errors.push("対象者数は整数で入力してください。");
  } else if (baseInfo.employees < 1 || baseInfo.employees > 99999) {
    errors.push("対象者数は0より大きい数値を設定してください。");
  }


  if (baseInfo.additionLimit === "") {
    errors.push("追加設問数を設定してください。");
  } else if (!isInteger(baseInfo.additionLimit)) {
    errors.push("追加設問数は整数で入力してください。");
  } else if (baseInfo.additionLimit < 0 || baseInfo.additionLimit > 20) {
    errors.push("追加設問数には0〜20の数値を設定してください。");
  }
  if (!baseInfo.termFrom || !baseInfo.termTo) {
    errors.push("公開期間を設定してください。");
  } else if (alertDays != null && alertDays !== '') {
    const termFromDate = moment(baseInfo.termFrom).startOf('day');
    const termToDate = moment(baseInfo.termTo).startOf('day');
    const alertDaysBefore = Number(alertDays);

    if (!Number.isNaN(alertDaysBefore)) {
      const alertDate = moment(termToDate).subtract(alertDaysBefore, 'days').startOf('day');

      if (alertDate.isBefore(termFromDate)) {
        errors.push("アラート日は公開期間内に設定してください。");
      }
    }
  } else {
    const isStatusAfterOpen =
      [SURVEY_STATUS.OPEN, SURVEY_STATUS.STOP].indexOf(survey.status) > -1;
    const isTermFromOver = moment(baseInfo.originTermFrom) < moment();
    const isTermFromModified = baseInfo.originTermFrom !== baseInfo.termFrom;

    if (
      isStatusAfterOpen && // 状態が公開か中断で、
      isTermFromOver && // 開始日時を過ぎていて、
      isTermFromModified // 開始日時を変更した場合
    ) {
      errors.push(
        "既に開始日時を過ぎているアンケートの開始日時を変更することはできません。"
      );
    }

    if (moment(baseInfo.termTo) < moment()) {
      errors.push(
        "公開期間の終了日時には現在日時以降の日時を設定してください。"
      );
    }

    if (baseInfo.termTo < baseInfo.termFrom) {
      errors.push("公開期間の終了日時が開始日時より前の日時になっています。");
    }
  }
  return errors;
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  //  init: () => dispatch(init()),
  historyPush: path => history.push(path, ownProps),
  fetchSurveyDetail: () => {
    const { params, path } = ownProps.match;
    const { id } = params;
    const url =
      path.indexOf("create_survey") > -1
        ? `create_survey/${id}`
        : `survey_detail/${id}`;
    api
      .get(url)
      .then(res => dispatch(setSurveyDetail(res)))
      .catch(error => dispatch(openErrorDialog(error)));
  },
  setAlertConfig: (alertDays, isChecked) => dispatch(setAlertConfig(alertDays, isChecked)),
  setMailSendToIndividual: (isMailSendToEmployee) => dispatch(setMailSendToIndividual(isMailSendToEmployee)),
  handleNext: props => {
    const { survey, baseInfo, alertDays, isChecked } = props;
    const errors = validate({ survey, baseInfo, alertDays, isChecked });
    dispatch(setErrors(errors));

    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }
    const { id } = ownProps.match.params;
    history.push(`/create_survey/${id}/select_attr`, ownProps);
  },
  handleRegist: props => {
    const { survey, baseInfo, selectAttr, baseWord, additions, alertDays, isChecked, isMailSendToEmployee } = props;
    let errors = validate({ survey, baseInfo, alertDays, isChecked });
    errors = errors.concat(selectAttrValidate(baseInfo, selectAttr));
    errors = errors.concat(baseWordValidate(baseInfo, baseWord));
    errors = errors.concat(additionsValidate(baseInfo, additions));
    dispatch(setErrors(errors));
    const data = selectAttr.items;
    const totalItemCounts = Object.values(data).reduce((list, item) => {
      if (item.isSelect) {
        return list + item.itemCount;
      }
      return list;
    }, 0);
    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    } else if (totalItemCounts > 45) {
      const { id } = ownProps.match.params;
      dispatch(setErrors(['属性選択肢の上限は条件によって異なりますのでご注意下さい。\nシステムのみを使用する場合：合計45 マークシートを併用する場合：合計36 （F1:12個、F2:6個、F3:6個、F4:6個、F5:6個）']));
      setTimeout(() => {
        ownProps.history.push(`/admin/create_survey/${id}/select_attr`);
        dispatch(setErrors([]));
      }, 3000);
      return;
    }

    const safeAlertDays = alertDays !== undefined && alertDays !== null ? alertDays : "";
    const safeIsChecked = typeof isChecked === "boolean" ? isChecked : false;
    const safeIsMailSendToEmployee = typeof isMailSendToEmployee === "boolean" ? isMailSendToEmployee : false;
    const params = {
      survey: survey.toObject(),
      baseInfo,
      selectAttr,
      baseWord,
      isChecked: safeIsChecked,
      alertDays: safeAlertDays,
      isMailSendToEmployee: safeIsMailSendToEmployee
    };

    const dialogData = {
      title: "確認",
      contentText: "入力した内容でアンケートを作成します。よろしいですか？",
      btnLabel: "作成",
      handleClick: () => {
        const { id } = ownProps.match.params;
        api
          .post(`create_survey/${id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());
            dispatch(updateBaseInfo());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("新規アンケートを作成しました。"));
              ownProps.history.push(`/admin/survey_detail/${res.survey.id}`);
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  handleUpdate: props => {
    const { survey, baseInfo, selectAttr, baseWord, additions, isChecked, alertDays, isMailSendToEmployee } = props;
    const errors = validate({ survey, baseInfo, isChecked, alertDays });
    dispatch(setErrors(errors));
    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }

    const params = {
      survey: survey.toObject(),
      baseInfo,
      selectAttr,
      baseWord,
      additions,
      isChecked,
      alertDays,
      isMailSendToEmployee
    };
    const dialogData = {
      title: "確認",
      contentText: "アンケート基本情報を変更します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        const { id } = ownProps.match.params;
        api
          .post(`update_base_info/${id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());
            dispatch(updateBaseInfo());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("アンケート基本情報を変更しました。"));
              ownProps.history.goBack();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  handleDelete: () => {
    const dialogData = {
      title: "確認",
      contentText: "アンケートを削除します。よろしいですか？",
      btnLabel: "削除",
      handleClick: () => {
        const { id } = ownProps.match.params;
        api
          .delete(`survey_detail/${id}`)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("アンケートを削除しました。"));
              ownProps.history.go(-2);
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  changeLocale: (event, localeNo) => {
    dispatch(setBaseInfoLocale(localeNo));
  },
  changeUseLocales: (event, localeNo) => {
    if (event.target.checked === false && localeNo === "ja") {
      dispatch(openMessageDialog("日本語を外すことはできません。"));
    } else {
      dispatch(changeBaseInfoUseLocales(event.target.checked, localeNo));
    }
  },
  changeItem: (key, value) => {
    dispatch(changeBaseInfoItem(key, value));
  },
  changeLocaleItem: (key, value, locale) => {
    dispatch(changeBaseInfoItem(key, value, locale));
  },
  changeTerm: (key, value) => {
    dispatch(changeBaseInfoTerm(key, value));
  },
  // 自由記入チェックボックスの変更
  changeFreeCommentCheckbox1: flg => {
    dispatch(changeFreeCommentCheckbox1(flg));
  },
  changeFreeCommentCheckbox2: flg => {
    dispatch(changeFreeCommentCheckbox2(flg));
  },
  openSelectSurveyModal: () => {
    dispatch(openSelectSurveyModal());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BaseInfo);



// WEBPACK FOOTER //
// ./src/containers/CreateSurvey/BaseInfo/index.js